"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerJakarta: ReactNode = (
  <>
    <section className="mb-6">
      <h2 className="text-xl font-bold mb-2">Kenapa Sewa Komputer Jakarta Jadi Pilihan Rasional?</h2>
      <p className="text-base mb-4">
        Di jantung kota yang sibuk seperti Jakarta, kebutuhan akan teknologi kerja harus cepat, stabil, dan bisa diandalkan.
        Daripada beli perangkat mahal dan depreciasi cepat, lebih efisien <strong>sewa komputer Jakarta</strong> dengan spesifikasi terkini, pengiriman cepat, dan teknisi standby.
      </p>
    </section>

    <section className="grid gap-4 mb-8">
      <article className="bg-white shadow rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-1">Distribusi Layanan Sewa Komputer Jakarta Luas & Cepat</h3>
        <p className="text-sm">
          Jaringan pengantaran aktif mencakup Jakarta Pusat, Selatan, Timur, Utara, dan Barat. <strong>Sewa komputer Jakarta</strong> dijamin cepat sampai. Cocok untuk kantor, workshop, event, hingga proyek dadakan.
        </p>
      </article>

      <article className="bg-white shadow rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-1">Komputer Ready Pakai: Core i5, SSD, RAM 8GB++</h3>
        <p className="text-sm">
          Semua unit <strong>komputer sewaan</strong> sudah terinstal, bisa langsung dipakai. Kamu bisa pilih tipe, brand, dan spek sesuai kebutuhan, baik untuk entry-level hingga editing profesional.
        </p>
      </article>

      <article className="bg-white shadow rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-1">Harga Sewa Komputer Jakarta Mulai 80Rb/Hari</h3>
        <p className="text-sm">
          Biaya <strong>sewa komputer di Jakarta</strong> sangat fleksibel. Semakin lama durasi, semakin hemat. Kamu juga bisa nego harga untuk jumlah unit besar atau acara korporasi.
        </p>
      </article>

      <article className="bg-white shadow rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-1">Support Teknis 24 Jam & Maintenance On-Site</h3>
        <p className="text-sm">
          Gangguan teknis? Tim support kami standby 24 jam. Kami bantu remote setup, install ulang, atau bahkan kirim unit pengganti langsung ke lokasi sewa komputer Jakarta kamu.
        </p>
      </article>

      <article className="bg-white shadow rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-1">Pengiriman Gratis ke Seluruh Jakarta</h3>
        <p className="text-sm">
          Untuk kamu yang <strong>sewa komputer Jakarta</strong> minimal 2 unit, kami beri fasilitas antar-jemput gratis. Termasuk instalasi awal seperti LAN, printer sharing, hingga instalasi software khusus.
        </p>
      </article>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-bold mb-2">Durasi Sewa Fleksibel: Harian, Mingguan, Bulanan</h2>
      <p className="text-base mb-4">
        Kamu bisa <strong>sewa komputer Jakarta</strong> mulai 1 hari untuk event singkat, seminggu untuk pelatihan, atau 3 bulan proyek kantor. Semuanya bisa disesuaikan, tanpa pinalti.
      </p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-bold mb-2">Pilihan Komputer & Brand Lengkap</h2>
      <p className="text-base mb-4">
        Tersedia brand seperti HP, Lenovo, Dell, Asus dengan berbagai tipe. Desktop tower, mini PC, hingga all-in-one. <strong>Sewa komputer di Jakarta</strong> dengan spek custom juga bisa kami siapkan.
      </p>
    </section>

    <section className="mb-6">
      <h2 className="text-xl font-bold mb-2">Keamanan Data Selama Masa Sewa</h2>
      <p className="text-base mb-4">
        Kami terapkan SOP wipe data dan enkripsi. Semua <strong>unit sewa komputer Jakarta</strong> dikosongkan setelah penggunaan. Privasi kamu aman 100%.
      </p>
    </section>

    <CTA
      title="Siap Kerja di Jakarta & Sekitarnya Tanpa Ribet?"
      description="🚚 Butuh sewa komputer Jakarta dengan harga fleksibel, spek sesuai kebutuhan, dan pengiriman instan? Chat kami sekarang juga. <br />Kami kirim hari ini juga, selama unit ready."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer%20untuk%20Jakarta.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerJakarta;